import { render, staticRenderFns } from "./DeliveryPromotions.vue?vue&type=template&id=e95284e2"
import script from "./DeliveryPromotions.vue?vue&type=script&lang=js"
export * from "./DeliveryPromotions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports